module.exports = __webpack_public_path__ + "img/24_jzs1_bg.ffa27b90.jpg";